export default {
  name: "name",
  sell_value: "sell_value"
};



// WEBPACK FOOTER //
// ./src/core/enum/product-batch-required.enum.js